function SvgComponent({ fillColor = '#EC0648', color = 'white', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3171 4C14.5938 4 14.8164 4.22533 14.8424 4.50133C14.959 5.69675 15.487 6.81459 16.3363 7.66382C17.1856 8.51305 18.3034 9.04096 19.4987 9.15733C19.774 9.184 20 9.406 20 9.68267V14.3173C20 14.594 19.7747 14.816 19.4987 14.8427C18.3034 14.959 17.1856 15.4869 16.3363 16.3362C15.487 17.1854 14.959 18.3033 14.8424 19.4987C14.8158 19.7747 14.5938 20 14.3171 20H9.68286C9.40555 20 9.18357 19.7747 9.1569 19.4987C9.0404 18.3034 8.51246 17.1856 7.66332 16.3364C6.81417 15.4872 5.6965 14.9592 4.50129 14.8427C4.22531 14.816 4 14.594 4 14.3173V9.68267C4 9.406 4.22531 9.184 4.50129 9.15733C5.6965 9.04082 6.81417 8.51284 7.66332 7.66362C8.51246 6.8144 9.0404 5.69664 9.1569 4.50133C9.18357 4.22533 9.40622 4 9.68353 4H14.3165H14.3171ZM7.2124 11.9867C7.21205 12.6193 7.33632 13.2459 7.57811 13.8305C7.8199 14.4152 8.17448 14.9465 8.6216 15.3941C9.06871 15.8416 9.59961 16.1968 10.184 16.4391C10.7683 16.6815 11.3947 16.8064 12.0273 16.8067C12.66 16.8064 13.2863 16.6815 13.8707 16.4391C14.4551 16.1968 14.9859 15.8416 15.4331 15.3941C15.8802 14.9465 16.2348 14.4152 16.4766 13.8305C16.7183 13.2459 16.8426 12.6193 16.8423 11.9867C16.8423 9.324 14.6864 7.16667 12.0273 7.16667C10.7497 7.16737 9.52475 7.67557 8.62179 8.57948C7.71884 9.48338 7.21187 10.709 7.2124 11.9867Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
